export default __webpack_public_path__ + "static/media/D5.84da0b35.mp3";